import { SubSink } from 'subsink';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { SocketioService } from 'src/app/services/socket/socketio.service';
import { ApiService } from 'src/app/services/api/api.service';
import { io } from 'socket.io-client';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-users-chat',
  templateUrl: './users-chat.page.html',
  styleUrls: ['./users-chat.page.scss'],
})
export class UsersChatPage implements OnInit {
  @ViewChild('scrollBottom') private myScrollContainer: ElementRef;
  subscription = new SubSink();
  chatUser: any = [];
  users: any = [];
  socket: any;
  message: string = '';
  receiver_id: string = '';
  showChat: boolean = false;
  showPanel:boolean = true;
  profilePlaceholder: string = '/assets/images/profile-placeholder.png';
  s3_bucket = environment.s3_bucket_url;

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if(window.innerWidth > 767){
      this.showPanel = true;
    }else if(this.showChat){
      this.showPanel = false;
    }
  }
  constructor(
    private socketService: SocketioService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private router: Router
  ) {
  }

  ngOnInit() {
  }



  ionViewWillEnter(){
    let angThis = this;
    this.getUsers();
    this.showChat = false;
    let token = this.apiService.getToken();
    this.socket = io(environment.base_url,{
      auth: { token },
    });
    this.socket.on('notify', function (data) {
      if(angThis.chatUser.user_id == data.sender_id){
        angThis.chatUser.messages.push({
          from_self: false,
          message_body: data.messageBody,
          sender_id: data.sender_id
        });
        setTimeout(() => {
          angThis.scrollToBottom();
        }, 200);
      }
    });

  }

  ionViewWillLeave(){
   if(this.socket.connect){
    this.socket.disconnect();
    this.showChat = false;
    this.showPanel = true;
   }
   this.subscription.unsubscribe();
  }

  displaySender(message, index) {
    return (
      index === 0 ||
      this.chatUser.messages[index - 1].fromSelf !==
        this.chatUser.messages[index].fromSelf
    );
  }

  selectedUser(user, selected_ele){
    if(window.innerWidth <= 767){
      this.showPanel = false;
    }
    const boxes = document.querySelectorAll('.users');
    boxes.forEach(box => {
      box.classList.remove('active-user-chat');
    });

    const selectedUser = document.querySelectorAll('.'+selected_ele);
    selectedUser.forEach(box => {
      box.classList.add('active-user-chat');
    });

    this.subscription.sink = this.apiService.get('chats/getSingleChat/'+user.user_id).subscribe(
    (res: any[]) => {
      let messages = [];
      this.showChat = true;
      let current_user_id = atob(this.route.snapshot.paramMap.get('venueId')!);
      res['data'].forEach(msg => {
        messages.push({
          conversation_id: msg.conversation_id,
          message_body: msg.message_body,
          receiver_id: msg.receiver_id,
          sender_id: msg.sender_id,
          from_self: (current_user_id == msg.sender_id) ? true : false,
        });
      });
      this.chatUser = user;
      console.log("chat user", this.chatUser);
      this.chatUser.conversation_id = user.conversation_id
      this.chatUser.messages = messages;
      setTimeout(() => {
        this.scrollToBottom();
      }, 200);

    })
  }

  scrollToBottom(): void {
    try {
        this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
    } catch(err) { }
  }

  showChatUsers(){
    if(window.innerWidth <= 767){
      this.showPanel = true;
      this.showChat = false;
    }
  }
  getUsers(){
    this.subscription.sink = this.apiService.get('chats/getUserChats').subscribe(
      (res: any[]) => {
        this.users = [];
        res['data'].forEach(user => {
          this.users.push({
            id: user?.id,
            username: user.first_name + ' ' + user.last_name,
            conversation_id: (user?.userMessages.length > 0) ? user.userMessages[0].conversation_id : '',
            user_id: user.id,
            profile_image: user?.user_account_information?.profile_image ? this.s3_bucket + user?.user_account_information?.profile_image : this.profilePlaceholder,
            account_type: (user?.account_type) ? user?.account_type?.account_type : '',
            account_type_id: (user?.account_type_id) ? user?.account_type_id : '',
          })
        });
    })
  }

  sendMessage(){

    this.chatUser.messages.push({
      conversation_id: this.chatUser.conversation_id,
      message_body: this.message,
      receiver_id: this.chatUser.user_id,
      sender_id: atob(this.route.snapshot.paramMap.get('venueId')!),
      from_self: true,
    });
    this.sendMessageToUser(this.message, this.chatUser.user_id, this.chatUser.conversation_id);
    this.message = '';
  }

  sendMessageToUser(message, receiver_id, conversation_id){
    let data = {
      messageBody: message,
      conversation_id: conversation_id,
      receiver_id: receiver_id
    }
    this.socket.emit('message', data);

    this.socket.once(conversation_id, res => {
      // console.log("socket on =======>", res);
      this.saveMessage(res);
      // console.log("message received from server =========>", res);
    })

    // this.socket.on('new message', res => {
    // });

  }

  saveMessage(data){
    let message = {
      'message_subject': 'private Message',
      'message_body': data.messageBody,
      'receiver_id': data.receiver_id,
      'conversation_id': data.conversation_id,
    };

    this.subscription.sink = this.apiService.post('chats/messages', message).subscribe(
      (res: any[]) => {
      // console.log("message saved successfully");
    });
    setTimeout(() => {
      this.scrollToBottom();
    });
  }

  goToProfile(account_type, user_id){
    let type = 'user';
    if(account_type == 1)
      type = 'band';
    else if(account_type == 2)
      type = 'comedian';
    else if(account_type == 3)
      type = 'food-truck';
    else if(account_type == 4)
      type = 'user';
    else if(account_type == 5)
      type = 'venue';
    else if(account_type == 6)
      type = 'comedy-club';
    else if(account_type == 7)
      type = 'artist';

    this.router.navigate([type + '/'+btoa(user_id)!]);
  }

}
